import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { MwLoadOptionsService } from './../services/utils/load-options.service';
import { MwLoadOptions } from './../models/load-options.model';
import { MwPayloadModel } from './../models/payload.model';
import { CustomerProjectApiModel, CustomerProjectModel } from 'app/models/customer-project-api.model';

@Injectable()
export class MwCustomerProjectsApiService {
  constructor(
    private http: MwHttpService,
    private loadOptionsService: MwLoadOptionsService
  ) {}

  getCustomerProjects(
    requestModel?: MwLoadOptions
  ): Observable<MwPayloadModel<CustomerProjectModel[]>> {
    const query = requestModel
      ? this.loadOptionsService.buildQuery(requestModel)
      : '';
    return this.http.authGet<MwPayloadModel<CustomerProjectModel[]>>(
      `/integration/v1/Companies/{companyId}/CustomerInternalProjects` +
        (query.length > 0 ? '?' + query : query)
    );
  }

  createCustomerProject(
    project: CustomerProjectApiModel
  ): Observable<CustomerProjectApiModel> {
    return this.http.authPost<CustomerProjectApiModel>(
      `/integration/v1/Companies/{companyId}/CustomerInternalProjects`,
      {
        body: project,
      }
    );
  }

  updateCustomerProject(
    project: CustomerProjectApiModel
  ): Observable<CustomerProjectApiModel> {
    return this.http.authPut<CustomerProjectApiModel>(
      `/integration/v1/Companies/{companyId}/CustomerInternalProjects`,
      {
        body: project,
      }
    );
  }

  deleteCustomerProject(project: CustomerProjectApiModel): Observable<any> {
    return this.http.authDelete(
      `/integration/v1/Companies/{companyId}/CustomerInternalProjects`,
      {
        body: project,
      }
    );
  }

  deleteCustomerProjectList(
    projects: CustomerProjectApiModel[]
  ): Observable<any> {
    return this.http.authDelete(
      `/integration/v1/Companies/{companyId}/CustomerInternalProjects/All`,
      {
        body: projects,
      }
    );
  }
}
